<div class="flex justify-end mb-2" *ngIf="!isLoading">
  <span class="text-sm text-gray-500">{{tableStructure.total_results}} {{'results' | translate}}</span>
</div>

<div class="w-full overflow-x-auto border border-gray-200 shadow-sm">
  <table mat-table [dataSource]="tableStructure.data" [ngClass]="config.class" class="min-w-full">

    <!-- Dynamic data columns -->
    <ng-container *ngFor="let col of tableStructure.tableColumns" [matColumnDef]="col.colId">
      <th mat-header-cell *matHeaderCellDef class="px-4 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wide bg-gray-50 whitespace-nowrap border-b border-gray-200">
        {{col.header_name | translate}}
      </th>
      <td mat-cell *matCellDef="let row" [ngClass]="'column-' + col['name']" class="px-4 py-3 text-sm text-gray-800 border-b border-gray-100">
        <span *ngIf="col['type'] == 'text'">
          {{(!empty(col['subName']) && !empty(row[col['name']]) && !empty(row[col['name']][col['subName']]))
          ? row[col['name']][col['subName']]
          : row[col['name']] | translate}}
        </span>
        <span *ngIf="col['type'] == 'date'">
          {{(!empty(col['subName'])) ? row[col['name']][col['subName']] : row[col['name']] | date:'YYYY-MM-dd'}}
        </span>
        <span *ngIf="col['type'] == 'array' && row[col['name']].length > 0">
          <span *ngFor="let single of row[col['name']]; let i = index;">
            {{(col['field'] && col['field'] !== '' ? single[col['field']] : single)}}{{i === row[col['name']].length - 1 ? '' : ', '}}
          </span>
        </span>
        <span *ngIf="col['type'] == 'image' && row[col['name']] !== null">
          <img class="image" [ngClass]="col['class']" [src]="row[col['name']]" />
        </span>
      </td>
    </ng-container>

    <!-- Actions column (sticky right) -->
    <ng-container matColumnDef="__actions">
      <th mat-header-cell *matHeaderCellDef
          class="px-4 py-3 bg-gray-50 border-b border-gray-200 border-l border-l-gray-200 sticky right-0 z-10">
      </th>
      <td mat-cell *matCellDef="let row"
          class="column-buttons px-4 py-3 border-b border-gray-100 border-l border-l-gray-200 bg-white sticky right-0 z-10">

        <!-- Mobile (<md): Material menu with icons -->
        <div class="md:hidden">
          <button [matMenuTriggerFor]="actionsMenu"
                  class="inline-flex items-center justify-center w-8 h-8 rounded border border-gray-300 text-gray-600 hover:bg-gray-100 focus:outline-none transition-colors">
            &#8942;
          </button>
          <mat-menu #actionsMenu="matMenu" xPosition="before">
            <ng-container *ngFor="let button of config.buttons">
              <button mat-menu-item
                      *ngIf="!button.hasOwnProperty('closure') || button['closure'](row)"
                      (click)="buttonEvent.emit({event: button.event, data: row})">
                <fa-icon *ngIf="getButtonIcon(button.event)"
                         [icon]="getButtonIcon(button.event)"
                         class="mr-2 text-gray-500 w-4"></fa-icon>
                {{button.text | translate}}
              </button>
            </ng-container>
          </mat-menu>
        </div>

        <!-- Desktop (≥md): icon-only on md–xl, icon + label on xl+ -->
        <div class="hidden md:flex flex-wrap justify-end gap-1">
          <ng-container *ngFor="let button of config.buttons">
            <button *ngIf="!button.hasOwnProperty('closure') || button['closure'](row)"
                    [class]="getButtonClass(button.class)"
                    [title]="button.text | translate"
                    (click)="buttonEvent.emit({event: button.event, data: row})">
              <fa-icon *ngIf="getButtonIcon(button.event)"
                       [icon]="getButtonIcon(button.event)"></fa-icon>
              <span [class]="getButtonIcon(button.event) ? 'hidden xl:inline' : ''">
                {{button.text | translate}}
              </span>
            </button>
          </ng-container>
        </div>

      </td>
    </ng-container>

    <!-- Loading / no-results row -->
    <tr *matNoDataRow>
      <td [attr.colspan]="displayedColumns.length" class="px-4 py-10 text-center text-sm text-gray-500">
        {{ isLoading ? ('Loading...' | translate) : ('No results' | translate) }}
      </td>
    </tr>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-blue-50/30 transition-colors"></tr>

  </table>
</div>

<mat-paginator *ngIf="config.hasPagination" [length]="tableStructure.total_results" [pageSize]="tableStructure.limit" [pageIndex]="tableStructure.page - 1" [hidePageSize]="true" (page)="onPageChange($event)" class="mt-2">
</mat-paginator>
